export const whyChooseUsData = [
    {
        "title": "PROFRESSIONAL AND DEDICATE TEAM",
        "description": "Building architectures with modern technology.",
        "readMoreLink": "https://www.google.com"
    },
    {
        "title": "UNIQUE DESIGN",
        "description": "Building architectures with modern technology.",
        "readMoreLink": "https://www.google.com"
    },
    {
        "title": "AFFORDABLE AND FLEXIABLE",
        "description": "Building architectures with modern technology.",
        "readMoreLink": "https://www.google.com"
    },
    {
        "title": "24/7 SUPPORT",
        "description": "Building architectures with modern technology.",
        "readMoreLink": "https://www.google.com"
    },
]